import { Analytics } from "@dub/analytics/react";

/**
 * Dub Analytics component for tracking conversions
 */
export const DubAnalytics = Analytics;

/**
 * Track a lead conversion event with Dub
 * 
 * @param clickId - The unique dub_id parameter from the URL
 * @param userId - The unique ID of the user in Clerk
 * @param eventName - The name of the event (e.g., "waitlist_signup")
 * @param customerEmail - Optional email address of the customer
 * @param customerName - Optional name of the customer
 * @param customerAvatar - Optional avatar URL of the customer
 */
export const trackLead = async (
  clickId: string,
  userId: string,
  eventName: string,
  customerEmail?: string,
  customerName?: string,
  customerAvatar?: string
) => {
  try {
    const response = await fetch('https://api.dub.co/track/lead', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${import.meta.env.VITE_DUB_API_KEY || process.env.DUB_API_KEY}`
      },
      body: JSON.stringify({
        clickId,
        eventName,
        externalId: userId,
        ...(customerEmail && { customerEmail }),
        ...(customerName && { customerName }),
        ...(customerAvatar && { customerAvatar }),
      })
    });
    
    if (!response.ok) {
      console.error('Failed to track lead event:', await response.text());
    }
    
    return response.ok;
  } catch (error) {
    console.error('Error tracking lead event:', error);
    return false;
  }
};

/**
 * Get the dub_id parameter from the URL
 * 
 * @returns The dub_id parameter from the URL or null if not present
 */
export const getDubClickId = (): string | null => {
  if (typeof window === "undefined") return null;
  
  const urlParams = new URLSearchParams(window.location.search);
  return urlParams.get("dub_id");
};
